import React from "react";
import "./Home.scss";
import images from "../../Data/images";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import Services from "../../Common/Services/Services";
import Contact from "../../Pages/Contact/Contact";
import Homepage from "../../Pages/Homepage/Homepage";
import About from "../../Common/About/About";
import TestimonialCarousel from "../../Common/Testimonials";

const Home = () => {
  return (
    <div className="home">
      <div className="main">
        <Homepage />
      </div>
      <div className="about">
        <About />
      </div>
      <TestimonialCarousel/>
    </div>
  );
};

export default Home;
